import React, { useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Switch } from '@mui/material';

// icons ----------------------------------
import { FaCircleInfo } from "react-icons/fa6";
import { FaLock } from "react-icons/fa";
import { LuSquareArrowOutUpRight } from "react-icons/lu";
import { FaCalendarAlt } from "react-icons/fa";
import { FaUserShield } from "react-icons/fa6";
import { FaShieldAlt } from "react-icons/fa";
import { FaCloudUploadAlt } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { FaCircleCheck } from "react-icons/fa6";
import { HiMiniExclamationTriangle } from "react-icons/hi2";
import { FaKey } from "react-icons/fa6";
import { TbCircleDotted } from "react-icons/tb";
import { BsQuestion } from "react-icons/bs";
import { LuRefreshCw } from "react-icons/lu";
import { MdOutlineAccessTimeFilled } from "react-icons/md";
import { TiStarburst } from "react-icons/ti";
import { FaArrowRotateLeft } from "react-icons/fa6";
import { FaDownload } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import { FaSave } from "react-icons/fa";
import { ArrowRotateLeft, Settings } from '../../../../../../../components/icons/Icons';




const AuditSettings = () => {

  const now = 24

  const [isRetention, setIsRetention] = useState("Standard")

  const [retentionPeriod, setRetentionPeriod] = useState([
    { id: 1, period: "1", retention: "Year", type: "Standard" },
    { id: 2, period: "3", retention: "Year", type: "Extended" },
    { id: 3, period: "7", retention: "Year", type: "Maximum" },
    { id: 4, period: <Settings />, retention: "Custom", type: "Configure" },
  ])

  return (
    <div className='audit-settings'>

      <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
        <div>
          <h3 className='color-white font-weight-200'>Audit Settings & Compliance</h3>
          <span className='color-gray font-weight-200 font-14'>Configure audit trail settings, data retention, and compliance controls</span>
        </div>
        <div className='d-flex align-items-center gap-2'>
          <span className='badge-green'>
            <div className='two-icons' style={{ marginLeft: "9px", marginRight: "10px" }}>
              <TbCircleDotted className='icon' /><BsQuestion className='icon-1' />
            </div>
            High Compliance
          </span>

          <ArrowRotateLeft class_name={"text-purple"} />  <span className='color-gray font-weight-200 font-14'>Last backup: 2 hours ago</span>
        </div>
      </div>


      <div className='compliance-notice'>
        <span className='first-icon'><FaCircleInfo className='icon' /></span>
        <div>
          <h3 className='color-white font-weight-200'>Compliance Notice</h3>
          <p className='color-white font-weight-200 mt-2'>These audit settings ensure compliance with data protection regulations and internal security policies. Changes to tamper-proof mode and retention periods may require administrator approval.</p>
        </div>
        <div className='last-icons'>
          <div className='first-icon-box'>
            <FaLock /> Secure
          </div>
          <LuSquareArrowOutUpRight className='exit' />
        </div>
      </div>


      <Row className=''>
        <Col sm="6" className='mt-4'>
          <div className='setting-border'>
            <div className='setting-card-header'>
              <h3 className='color-white font-weight-200'> <FaCalendarAlt className='clndr-icon' /> Data Retention Period </h3>
              <span className='color-gray font-14 font-weight-200'>Fomrs & Logos</span>
            </div>

            <div className='p-4'>
              <h4 className='color-gray font-weight-200'>Choose how long to keep Form 12BB submissions and audit logs</h4>

              <Row>
                {
                  retentionPeriod.map((item) => {
                    return <Col sm="6" className='mt-3'>
                      <div onClick={() => setIsRetention(item.type)} className={`Data-Retention-Period-col cursor-pointer ${item.type == isRetention ? "active" : ""} `} key={item.type}>
                        <h3>{item.period}</h3>
                        <p>{item.retention}</p>
                        <p>{item.type}</p>
                      </div>
                    </Col>
                  })
                }
              </Row>

              <hr className='color-gray mt-4' />

              <div>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div>
                    <h3 className='color-white font-weight-200'>Current Storage Usage</h3>
                    <h5 className='color-gray font-weight-200 mt-1'>2.4 GB of 10 GB allocated</h5>
                  </div>

                  <div>
                    <h3 className='percentage-purple'>24%</h3>
                    <h5 className='color-gray font-12 font-weight-200 mt-1'>Used</h5>
                  </div>
                </div>
                <ProgressBar now={now} label={`${now}%`} visuallyHidden className='custom-bar mt-3' />
              </div>
            </div>

          </div>
        </Col>


        <Col sm="6" className='mt-4'>
          <div className='setting-border'>
            <div className='setting-card-header'>
              <h3 className='color-white font-weight-200'> <FaUserShield className='clndr-icon' /> Access Control</h3>
              <span className='color-gray font-14 font-weight-200'>Permissions</span>
            </div>

            {/* ------------------ */}
            <div className='px-4 mt-4 mb-4'>
              <div className='setting-switch-enbl-dsbl active'>
                <div className='content'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <FaLock className='active-green-icon' />
                    <div>
                      <h3 className='color-white'>Export Permissions</h3>
                      <h5 className='color-gray'>Allow HR/Admin to export audit trail</h5>
                    </div>
                  </div>
                  <Switch checked onChange={() => console.log("hello")} />
                </div>
                <p className='color-gray'> <HiMiniExclamationTriangle className='icon-exclamation' /> Enabled for: HR Approver, Payroll Auditor</p>
              </div>
            </div>
            {/* --------------------------- */}
            <div className='px-4 mb-4'>
              <div className='setting-switch-enbl-dsbl active'>
                <div className='content'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <FaKey className='active-green-icon' />
                    <div>
                      <h3 className='color-white'>Approver-Only Audit Logs</h3>
                      <h5 className='color-gray'>Only approvers can see audit logs</h5>
                    </div>
                  </div>
                  <Switch checked onChange={() => console.log("hello")} />
                </div>
                <p className='color-gray'> <FaCheck className='active-icon-check' /> Restricted to approval authority roles </p>
              </div>
            </div>
            {/* --------------------------- */}
            <div className='px-4 mb-4'>
              <div className='setting-switch-enbl-dsbl'>
                <div className='content'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <FaLock className='active-green-icon' />
                    <div>
                      <h3 className='color-white'>Employee Self-View</h3>
                      <h5 className='color-gray'>Allow employees to view their own audit history</h5>
                    </div>
                  </div>
                  <Switch checked onChange={() => console.log("hello")} />
                </div>
                <p className='exclamation'> <HiMiniExclamationTriangle className='icon-exclamation' /> Transparency for employee actions</p>
              </div>
            </div>

            <div className='px-4 mb-4'>
              <h3 className='color-white mb-3'>Role-Based Access Levels</h3>

              <div className='mb-1 d-flex align-items-center justify-content-between'>
                <span className='color-white'>HR Reviewer</span>
                <span className='green-text'>View Own Actions</span>
              </div>

              <div className='mb-1 d-flex align-items-center justify-content-between'>
                <span className='color-white'>HR Approver</span>
                <span className='green-text'>Full Audit Access</span>
              </div>

              <div className='mb-1 d-flex align-items-center justify-content-between'>
                <span className='color-white'>Payroll Auditor</span>
                <span className='green-text'>Read-Only Access</span>
              </div>

              <div className='mb-1 d-flex align-items-center justify-content-between'>
                <span className='color-white'>Employee</span>
                <span className='color-gray'>No Access</span>
              </div>
            </div>
          </div>
        </Col>


        <Col sm="6" className='mt-4'>
          <div className='setting-border'>
            <div className='setting-card-header'>
              <h3 className='color-white font-weight-200'> <FaShieldAlt className='clndr-icon' /> Security & Integrity</h3>
              <span className='secure font-14 '><FaCheck /> Secure</span>
            </div>

            <div className='px-4 mt-4 mb-4'>
              <div className='setting-switch-enbl-dsbl active'>
                <div className='content'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <FaLock className='active-green-icon' />
                    <div>
                      <h3 className='color-white'>Tamper-Proof Mode</h3>
                      <h5 className='color-gray'>Enable immutable audit logs</h5>
                    </div>
                  </div>
                  <Switch checked onChange={() => console.log("hello")} />
                </div>
                <p className='exclamation'> <HiMiniExclamationTriangle className='icon-exclamation' /> Once enabled, logs cannot be modified or deleted</p>
              </div>
            </div>
            {/* --------------------------- */}
            <div className='px-4 mb-4'>
              <div className='setting-switch-enbl-dsbl active'>
                <div className='content'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <FaKey className='active-green-icon' />
                    <div>
                      <h3 className='color-white'>Data Encryption</h3>
                      <h5 className='color-gray'>AES-256 encryption for stored data</h5>
                    </div>
                  </div>
                  <Switch checked onChange={() => console.log("hello")} />
                </div>
                <p className='encryption'> <FaCheck className='active-icon-check' /> Always enabled for compliance </p>
              </div>
            </div>
            {/* --------------------------- */}
            <div className='px-4 mb-4'>
              <div className='setting-switch-enbl-dsbl'>
                <div className='content'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <TiStarburst style={{ fontSize: "24px" }} className='active-green-icon' />
                    <div>
                      <h3 className='color-white'>Digital Signatures</h3>
                      <h5 className='color-gray'>Sign critical audit events</h5>
                    </div>
                  </div>
                  <Switch checked onChange={() => console.log("hello")} />
                </div>
                <p className='exclamation'> <HiMiniExclamationTriangle className='icon-exclamation' /> Enhanced security for sensitive operations</p>
              </div>
            </div>
            {/* --------------------------- */}
            <div className='px-4 mb-4'>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <div>
                  <h3 className='color-white font-weight-200'>Current Storage Usage</h3>
                  <h5 className='color-gray font-weight-200 mt-1'>2.4 GB of 10 GB allocated</h5>
                </div>

                <div>
                  <h3 className='high-green'>


                    <div className='two-icons' style={{ marginLeft: "9px", marginRight: "10px" }}><TbCircleDotted className='icon' /><BsQuestion className='icon-1' /></div>


                    High</h3>
                  {/* <h5 className='color-gray font-12 font-weight-200 mt-1'>Used</h5> */}
                </div>
              </div>
              <ProgressBar now={now} label={`${now}%`} visuallyHidden className='custom-bar-green mt-3' />
            </div>

          </div>
        </Col>


        <Col sm="6" className='mt-4'>
          <div className='setting-border'>
            <div className='setting-card-header'>
              <h3 className='color-white font-weight-200'> <FaCloudUploadAlt className='clndr-icon' />Backup Settings </h3>
              <span className='active font-14 '><FaCircleCheck /> Active</span>
            </div>

            {/* --------------------------- */}
            <div className='px-4 mb-4 mt-4'>
              <div className='setting-switch-enbl-dsbl active'>
                <div className='content'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <LuRefreshCw className='active-green-icon' />
                    <div>
                      <h3 className='color-white'>Auto-Backup Logs</h3>
                      <h5 className='color-gray'>Automatic backup to secure storage</h5>
                    </div>
                  </div>
                  <Switch checked onChange={() => console.log("hello")} />
                </div>
                <p className='encryption'> <MdOutlineAccessTimeFilled className='active-icon-check' /> Last backup: 2 hours ago</p>
              </div>

              <h4 className='color-gray font-weight-200 mt-4'>Backup Frequency</h4>
              <Form.Group>
                <Form.Check type="radio" label={<div className='color-white'> Hourly <span className='color-gray font-12 font-weight-200'>(High frequency)</span> </div>} />
              </Form.Group>

              <Form.Group className='mt-2'>
                <Form.Check type="radio" label={<div className='color-white'> Daly <span className='color-gray font-12 font-weight-200'>(Recommended)</span> </div>} />
              </Form.Group>

              <Form.Group className='mt-2  mb-2'>
                <Form.Check type="radio" label={<div className='color-white'> Basic <span className='color-gray font-12 font-weight-200'>(Basic)</span> </div>} />
              </Form.Group>


              <hr className='color-gray' />

              <h4 className='color-white mb-3 font-weight-200'>Backup Statistics</h4>

              <Row className='mt-4'>
                <Col sm="6" className='mb-4 total-backups'>
                  <h3>1,247</h3>
                  <h5>Total Backups </h5>
                </Col>

                <Col sm="6" className='mb-4 success-rate'>
                  <h3>1,247</h3>
                  <h5>Success Rate</h5>
                </Col>

                <Col sm="6" className='mb-4 total-size '>
                  <h3>1,247</h3>
                  <h5>Total Size </h5>
                </Col>

                <Col sm="6" className='mb-4 avg-time'>
                  <h3>1,247</h3>
                  <h5>Avg Time</h5>
                </Col>
              </Row>
            </div>
            {/* --------------------------- */}
          </div>
        </Col>
      </Row>


      <div className='d-flex align-items-center justify-content-between mt-4 mb-4'>
        <div className='d-flex align-items-center justify-content-start gap-3'>
          <span className='color-white'> <FaArrowRotateLeft /> Reset to Defaults</span>
          <span className='green-text'> <FaDownload /> Export Settings</span>
        </div>
        <div className='d-flex align-items-center justify-content-start gap-3'>
          <button className='universal-sec-btn border-radius-8px d-flex align-items-center justify-content-center gap-2'><FaTimes /> Cancel Changes</button>
          <button className='universal-btn border-radius-8px d-flex align-items-center justify-content-center gap-2'><FaSave /> Save & Apply Changes</button>
        </div>
      </div>

    </div>
  )
}

export default AuditSettings